import React, { useState, useEffect, useRef } from 'react';
import { IoChevronForward } from 'react-icons/io5'; // Dropdown icon
import { IoEllipse } from 'react-icons/io5'; // Icon for dot

const DropdownBonus = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const gameIds = ["All Bonus Type", "Quest Bonus", "Lucky Spin", "Roll Competition", "Deposit Bonus", "Recharge", "Weekly Bonus", "Monthly Bonus", "Sport Weekly Bonus","Level-up Bonus"];
  const [selectedGameId, setSelectedGameId] = useState("All Bonus Type");

  // Close dropdown when clicked outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  return (
    <div className='dropdown-Bonusdetail game-fonts'>
      <div className="dropdown-container" ref={dropdownRef}>
        <div
          className="dropdown-button"
          onClick={() => setIsOpen(!isOpen)}
        >
          <span>{selectedGameId}</span>
          <IoChevronForward
            className={`dropdown-icon ${isOpen ? 'rotate-90' : 'rotate-0'}`}
          />
        </div>

        {isOpen && (
          <ul className="dropdown-list game-fonts">
            {gameIds.map((gameId) => (
              <li
                key={gameId}
                className={`dropdownbonus-item ${selectedGameId === gameId ? 'selectedBonus' : ''}`}
                onClick={() => setSelectedGameId(gameId)}
              >
                <div className='dropdown-bonus-content game-fonts'>{gameId}</div>
                <div className={`icon-container ${selectedGameId === gameId ? 'active' : ''}`}>
                  <div className="bg-circle"></div>
                  <IoEllipse className="icon" />
                </div>
              </li>
            ))}
          </ul>
        )}
      </div>
    </div>
  );
};

export default DropdownBonus;
